import http from './httpService';

export function getAllPotentialRiskTypes() {
  return http.get(`/potential-risk-types`);
}
export function updatePotentialRiskType(payload) {
  return http.put(`/potential-risk-types`, payload);
}
export function deletePotentialRiskType(id) {
  return http.delete(`/potential-risk-types/${id}`);
}
export function createPotentialRiskType(payload) {
  return http.post(`/potential-risk-types`, payload);
}
